import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { CONSTANTS } from '../services/constants';

/**
 * Custom hook to check if is from my-learning
 *
 * @returns boolean
 */
const useMyLearning = () => {
  const router = useRouter();

  const viewType = useMemo(() => {
    return router.query.view
      ? decodeURIComponent(<string>router.query.view)
      : undefined;
  }, [router.query.view]);

  return viewType === CONSTANTS.MY_LEARNING;
};

export default useMyLearning;
